<template>
  <Modal :value="value" @hide="hide()" title="Add existing repository">
    <template slot="body" class="content">
      <div class="margin-bottom-1">
        <BInput
          v-model="repoName"
          type="text"
          validation="required"
          placeholder="Repo name"
          name="name"
          focus="true"
          hideError="true"
        ></BInput>

        <BInput
          v-model="repoUrl"
          type="url"
          validation="required"
          placeholder="Repo url"
          name="name"
          hideError="true"
          @valid="valid = $event"
        ></BInput>
      </div>
      <div class="notification is-primary is-light">
        The nuget repository should be verison 2 and pre-authenticated. Don't
        include /Packages in the URL field.
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div @click="save()" :disabled="!valid" class="button is-success">
          Save
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
  },
  data() {
    return {
      repoName: "",
      repoUrl: "",
      valid: false,
      isLoading: false,
    };
  },

  methods: {
    async save() {
      if (!this.isLoading && this.repoName && this.valid) {
        let url = this.repoUrl.trim();

        if (url.toLowerCase().startsWith("http://")) {
          this.$helpers.notify("Error", "SSL (HTTPS) is required.", "warning");
          return;
        }

        try {
          if (!url.endsWith("/")) url += "/";

          this.isLoading = true;
          await this.$store.dispatch("source/createExternal", {
            name: this.repoName.trim(),
            url: url,
          });
        } catch (error) {
          console.error(error);
        }

        this.isLoading = false;
        this.hide();
      }
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
